(function documentControllerDefinition() {
    'use strict';

    angular.module('Document')
        .controller('DocumentDetailImagesController', [
            '$scope', '$translate', '$state', 'errorsExtend', '$stateParams', 'documentService', 'fileService', 'fileDownloader', 'authExtend', 'auth', 'alerts', '$q', 'storageService', 'documentAction', 'myDocument', '$filter', 'imageService', 'config',
            function documentDetailImagesController($scope, $translate, $state, errors, $stateParams, documentService, fileService, fileDownloader, authExtend, auth, alerts, $q, storageService, documentAction, myDocument, $filter, imageService, config) {

        $scope.UserId = authExtend.getUserId();
        $scope.urlFind = undefined;
        $scope.noImages = false;
        $scope.myDocument = myDocument;
        
        $scope.preview = {
            loading: false,
            content: null,
            index: null,
            item: null,
            invalid: false,
            containerTab: true
        };

        $scope.auditEntity = {
            creationDate: new Date(),
            userId: auth.getUserId(),
            userName: auth.getUserNick(),
            applicationId: config.appId(),
            applicationName: config.appName(),
            organizationalUnitId: auth.getOrganizationId(),
            organizationalUnitName: auth.getOrganizationName(),
            actionType: { id: 37 }//FileDownLoad
        };

        $scope.initDocumentFind = function () {
            if ($scope.urlFind) {
                $state.go($scope.urlFind);
            }
        };

        $scope.goBackToContainer = function () {
            $state.go('document-container-detail-from-doc', { id: $scope.containerId, docId: $scope.document.id });
        };

        $scope.cancel = function () {
            if (storageService.getStateBackFind()) {
                $state.go(storageService.getStateBackFind());
            } else {
                $state.go('document-find');
            }
        };

        $translate(['DocumentVersionDetail']).then(function (translated) {
            $scope.title = translated.DocumentVersionDetail;
        });

        $scope.loadDocument = function () {
            var defered = $q.defer();
            var promise = defered.promise;

            if ($stateParams.nro) {
                documentService.getVersion($stateParams.id, $stateParams.nro).then(function (result) {
                    $scope.document = result;
                    defered.resolve(result);
                }, function (error) {
                    defered.reject(error);
                });
            } else {
                documentService.getById($stateParams.id, myDocument).then(function (result) {
                    $scope.document = result;
                    defered.resolve(result);
                }, function (error) {
                    defered.reject(error);
                });
            }

            return promise;
        }

        $scope.loadImages = function () {
            var defered = $q.defer();
            var promise = defered.promise;

            imageService.getImages($stateParams.id).then(function (result) {
                $scope.images = result;

                if ($scope.images.length == 0) {
                    $scope.noImages = true;
                }

                defered.resolve(result);
            }, function (error) {
                defered.reject(error);
            });

            return promise;
        }

        $scope.generatePDF = function () {
            return imageService.generatePDF($scope.document.id)
                .then(function () {
                    $scope.load();
                    if ($scope.images.length == 0) {
                        $state.goBack('mydocument-detail', { id: $scope.document.id });
                    }
                }, function (error) {
                    errors.showError(error);
                });
        }

        $scope.load = function () {
            $scope.images = [];

            $scope.urlFind = storageService.getStateBackFind();

            var promesaMultipleArray = $q.all([$scope.loadDocument(),
                                               $scope.loadImages()]);

            promesaMultipleArray.then(function () {
                $scope.document.documentTypes.forEach(function (docType) {
                    docType.metadatas.sort(function (a, b) {
                        return a.position - b.position;
                    });
                });

                if ($scope.downloadBtn) {
                    $scope.downloadBtn = ($scope.images.length > 0);
                }

                if ($stateParams.containerId) {
                    $scope.document.containers.forEach(function (cont) {
                        if (cont.id.toString() === $stateParams.containerId.toString()) {
                            $scope.containerId = $stateParams.containerId;
                            return;
                        }
                    });
                }

                $scope.previewFile($scope.images, 0);

            }, function (error) {
                errors.showError(error);
                $scope.cancel();
            });
        }

        $scope.previewFile = function (item, index) {
            $scope.preview.content = null;
            $scope.preview.loading = true;
            $scope.preview.invalid = false;
            if ($scope.images && $scope.images.length > 0) {
                imageService.getById($scope.images[index].id).then(function (image) {
                    $scope.preview.content = fileService.base64ToBlob(image.base64File, 'application/pdf');

                    $scope.preview.item = $scope.images[index];
                    $scope.preview.index = index;
                    $scope.preview.loading = false;

                    $scope.auditEntity.entityid = $scope.document.id;
                    $scope.auditEntity.EntityName = 'DOCUMENT';
                    $scope.auditEntity.entity = JSON.stringify({
                        documentId: $scope.document.id,
                        documentTypeName: $scope.document.documentTypes[0].documentTypeName,
                        documentName: $scope.document.name,
                        fileCreatedBy: $scope.document.createdByNickName,
                        fileCreationDate: $scope.preview.item.creationDate,
                        fileDownloadedBy: auth.getUserNick(),
                        fileDownloadedDate: new Date(),
                        organizationalUnit: auth.getOrganizationId(),
                        metadatas: $scope.document.documentTypes[0].metadatas.map(function (obj) {
                            var rObj = {};
                            rObj[obj.systemName] = obj.metadataValue;
                            return rObj;
                        })
                    });

                }, function (error) {
                    if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                        $scope.preview.loading = false;
                        $scope.preview.invalid = true;
                        $scope.preview.item = $scope.images[index];
                        $scope.preview.index = index;
                    }
                    else {
                        errors.showError(error);
                    }
                });
            }
        };

        $scope.nextPreview = function () {
            if ($scope.preview.index + 1 < $scope.images.length) {
                $scope.preview.index++;
                $scope.previewFile($scope.images, $scope.preview.index);
            }
        };

        $scope.prevPreview = function () {
            if ($scope.preview.index) {
                $scope.preview.index--;
                $scope.previewFile($scope.images, $scope.preview.index);
            }
        };

        $scope.goBack = function () {
            $state.goBack('mydocument-detail', { id: $scope.document.id });
        };

        $scope.downloadFile = function (image) {
            var defered = $q.defer();
            var promise = defered.promise;
            imageService.download(image.id).then(function (result) {
                var success = fileDownloader.saveAs(result, image.fileName);

                if (!success) {
                    defered.reject('Api failed');
                }

                defered.resolve(result);

            }, function (error) {
                if (error.status === 204) {
                    defered.reject('The document has no files');
                } else {
                    defered.reject('Api failed');
                }
            });

            return promise;
        }

        $scope.exportToExcel = function () {
            var table = $('#table').clone()
             .find('th:last-child, td:last-child').remove().end()
             .prop('outerHTML');

            var result = new Blob([table], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
            });
            saveAs(result, $filter('translate')("ImageDetailExcelFileName") + '.xls');
        };

        $scope.load();
    }
        ]);
})();